import type { ToggleButtonDesignTokens } from '@primeuix/themes/types/togglebutton';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { tDeep, tFlat, t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/togglebutton/index.ts
const tb = componentCommon.togglebutton;
const tbCs = tDeep(componentColorScheme.togglebutton);

export const ToggleButtonTelekomDT: ToggleButtonDesignTokens = {
  root: {
    padding: t(tb.padding),
    focusRing: tFlat(tb.focus.ring),
  },
  colorScheme: {
    light: {
      root: {
        background: tbCs.background,
        hoverBackground: tbCs.hover.background,
        color: tbCs.color,
        borderColor: tbCs.border.color,
        checkedBorderColor: tbCs.checked.border.color,
        checkedBackground: tbCs.checked.background,
        checkedColor: tbCs.checked.color,
      },
      content: {
        checkedBackground: tbCs.content.checked.background,
      },
    },
  },
};
